<div fxLayout="row" fxLayoutAlign="center center">
    <span> {{"view_time"|translate}} </span>
</div>

<div class="flex flex-col sm:flex-row justify-center">
    <!-- <app-single-date-inlinePicker class="w-full sm:w-2/4" style="max-width: 350px;" [product]="product" [disabledDates]="disabledDates" [timeslots]="timeslots" [date]="form.get('date')"></app-single-date-inlinePicker> -->

    <div class="flex flex-col ms-4 sm:m-0">
        <div class="flex flex-col justify-center" *ngIf="this.form.get('date').value && timeslots?.length > 0"><span style="margin: 20px 20px; text-align: center;"> {{"select_time"|translate}} </span></div>
        <div class="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-5 gap-4 ">
            <div class="timeslot flex flex-col" *ngFor="let timeslot of timeslots" (click)="addRemoveTimeslot(timeslot)" [ngClass]="{selected: isSelected(timeslot), second: true, third: false}">
                <div style="font-size: medium;  text-align: center;">{{ timeslot.range?.start | date: "shortTime" }}</div>
                <div style="font-size: medium;  text-align: center;">{{ timeslot.range?.end | date: "shortTime" }}</div>
            </div>

        </div>
    </div>
</div>

<div *ngIf="form.get('timeslots')?.value?.length > 0" fxLayout="column" style="min-width: 100%; margin-top: 21px" fxLayoutAlign="center center">
    <div fxLayout="row" style="min-width: 100%; margin-top: 21px" fxLayoutAlign="center center">
        <!-- List picked timeslots -->
        <div class="list">
            <span class="m-4" fxFlexAlign="center"> {{"chosen_timeslots"|translate}}: </span>
            <div *ngFor="let timeslot of form.get('timeslots').value; let i = index" class="pt-2">
                <div fxLayout="row" fxLayoutAlign="space-around center" class="timeslot-list-item">
                    <span style=" text-align: center; margin-left: 5px; margin-right: 6px;">{{"from"|translate}}: {{ timeslot.start | date: "short" }}</span>
                    <span style=" text-align: center;">{{"to"|translate}}: {{ timeslot.end | date: "short" }}</span>
                    <button type="button" mat-icon-button (click)="removeTimeslot(i)"><mat-icon>close</mat-icon></button>
                </div>
            </div>
        </div>
    </div>
</div>